import { render } from "./premier_soins_page.vue?vue&type=template&id=746dcfa4"
import script from "./premier_soins_page.vue?vue&type=script&lang=js"
export * from "./premier_soins_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__